import { ProtectedComponent } from "components/Atomos/ProtectedComponent";
import { NotFound } from "components/Templates/NotFound";
import { RoleTypes } from "models/role-types.model";
import { Outlet } from "react-router-dom";

type ProtectedRouteProps = {
    rolesRequired: RoleTypes[];
}

const RedirectToLogin = () => {
    return <NotFound goBackTo="/login" />;
}

const ProtectedRoute = ({
    rolesRequired
}: ProtectedRouteProps) => {
    return (
        <ProtectedComponent rolesRequired={rolesRequired} unauthorizedComponent={<RedirectToLogin />}>
            <Outlet />
        </ProtectedComponent>
    );
}
export default ProtectedRoute